import type { ReactNode } from "react";

/**
 * Access levels for the declarative routing system.
 */
export enum AccessLevel {
    AUTHENTICATED = "AUTHENTICATED",
    EMAIL_VERIFIED = "EMAIL_VERIFIED",
    BILLING_ACTIVE = "BILLING_ACTIVE",
    COUNCIL_VERIFIED = "COUNCIL_VERIFIED",
    SECRETARY_PERMISSION = "SECRETARY_PERMISSION",
    CLINIC_MEMBER = "CLINIC_MEMBER",
    ADMIN = "ADMIN",
}

export type PermissionRequirement = {
    level: AccessLevel;
    /** When set with AUTHENTICATED, user.role must be one of these. */
    roles?: string[];
    /** Dot path for SECRETARY_PERMISSION, e.g. ["agenda", "view"]. */
    permissions?: string[];
    requireFinanceMenu?: boolean;
};

export type RouteConfig = {
    path?: string;
    index?: boolean;
    element?: ReactNode;
    access?: PermissionRequirement[];
    children?: RouteConfig[];
};
